import { Injectable, inject } from '@angular/core';
import { StorageService } from './storage.service';
import { OUTLAW_COOKIES } from '../../consts/cookie';
import { User } from '../../types/argo';
import { ExternalApiService } from '../external-api.service';
import { MobileEventsService } from './mobile-events.service';

@Injectable({
  providedIn: 'root',
})
export class ProfileService {
  private storageService = inject(StorageService);
  private externalApiService = inject(ExternalApiService);
  private mobileEventsService = inject(MobileEventsService);

  updateUserToken(token: string, options: { saveToLocalStorage: boolean } = { saveToLocalStorage: false }): void {
    this.storageService.set(OUTLAW_COOKIES.user_token, token);

    if (options.saveToLocalStorage || this.mobileEventsService.isWebView) {
      localStorage.setItem(OUTLAW_COOKIES.user_token, token);
    }
  }

  getUserToken(): string {
    return (
      this.storageService.get(OUTLAW_COOKIES.user_token) ||
      localStorage.getItem(OUTLAW_COOKIES.user_token) ||
      window?.authToken
    );
  }

  updateUserData<T = User>(user: T): void {
    localStorage?.setItem(OUTLAW_COOKIES.user_data, JSON.stringify(user));
  }

  getUser<T = User>(): T {
    const userDataStr = localStorage?.getItem(OUTLAW_COOKIES.user_data);
    if (userDataStr) {
      return this.storageService.getAsObject(userDataStr);
    }
    return null;
  }

  logout(): void {
    this.storageService.clearStorage();
    localStorage?.clear();
    this.externalApiService.resetSynchronization();
  }

  addGuest(data: any): void {
    this.storageService.set(OUTLAW_COOKIES.guest_data, JSON.stringify(data));
  }

  getGuest(): any {
    return this.storageService.get(OUTLAW_COOKIES.guest_data);
  }

  removeGuestUser(): void {
    this.storageService.remove(OUTLAW_COOKIES.guest_data);
  }

  removeUser(): void {
    this.storageService.remove(OUTLAW_COOKIES.user_token);
    this.storageService.remove(OUTLAW_COOKIES.user_data);
    localStorage?.removeItem(OUTLAW_COOKIES.user_token);
    localStorage?.removeItem(OUTLAW_COOKIES.user_data);
  }
}
